export default () => ({
  handler: 'absoluteUrl',
  data: ({ outcomeIds }) => `/betslip_recovery?outcomeids=[${(outcomeIds || []).join(',')}]`,
});
